// authentication
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const TOKEN_FETCH_ERROR = 'TOKEN_FETCH_ERROR';

// sidebar
export const ACTIVE_TAB = 'ACTIVE_TAB';

export const LOADER = 'LOADER';
export const ERROR = 'ERROR';

// application Details
export const GET_SINGLE_APPLICATION = 'GET_SINGLE_APPLICATION';

// Applications
export const GET_APPLICATIONS = 'GET_APPLICATIONS';

// Current Application Id
export const SET_CURRENT_APPLICATION_ID = 'SET_CURRENT_APPLICATION_ID';

export const RESET_APPLICATION_DATA = 'RESET_APPLICATION_DATA';

export const CLEAR_SINGLE_APPLICATION_DATA = 'CLEAR_SINGLE_APPLICATION_DATA';
export const GET_APPLICATION_STATUS_LIST = 'GET_APPLICATION_STATUS_LIST';

export const SET_BORROWER_DOC_LOADING = 'SET_BORROWER_DOC_LOADING';
export const SET_BORROWER_DOC_SUCCESS = 'SET_BORROWER_DOC_SUCCESS';
export const SET_BORROWER_DOC_ERROR = 'SET_BORROWER_DOC_ERROR';

export const SET_COBORROWER_DOC_LOADING = 'SET_COBORROWER_DOC_LOADING';
export const SET_COBORROWER_DOC_SUCCESS = 'SET_COBORROWER_DOC_SUCCESS';
export const SET_COBORROWER_DOC_ERROR = 'SET_COBORROWER_DOC_ERROR';

export const SET_DOC_LOADING = 'SET_DOC_LOADING';
export const SET_DOC_SUCCESS = 'SET_DOC_SUCCESS';
export const SET_DOC_ERROR = 'SET_DOC_ERROR';
export const SET_DOCUMENT_URL = 'SET_DOCUMENT_URL';
export const SET_DOCUMENT_GENERATION_STATUS = 'SET_DOCUMENT_GENERATION_STATUS';

export const GET_AUDIT_TRAIL_FOR_APPLICATION = 'GET_AUDIT_TRAIL_FOR_APPLICATION';
export const GET_DELETED_APPLICATIONS = 'GET_DELETED_APPLICATIONS';
export const GET_POST_SANCTION_DOCUMENT_PROCESSING_QUEUE = 'GET_POST_SANCTION_DOCUMENT_PROCESSING_QUEUE';


// Get OCR documents
export const GET_BORROWER_OCR_DOCS = 'GET_BORROWER_OCR_DOCS';
export const GET_COBORROWER_OCR_DOCS = 'GET_COBORROWER_OCR_DOCS';

// Tranche Details
export const GET_SINGLE_TRANCHE = 'GET_SINGLE_TRANCHE';
export const GET_USER_ALL_TRANCHES = 'GET_USER_ALL_TRANCHES';

// Tranche
export const GET_TRANCHES = 'GET_TRANCHES';

// Current Tranche Id
export const SET_CURRENT_TRANCHE_ID = 'SET_CURRENT_TRANCHE_ID';

export const GET_LOANS = 'GET_LOANS';

// Repayment Schedule of a Tranche
export const GET_REPAYMENT_SCHEDULE = 'GET_REPAYMENT_SCHEDULE';

// Get Insurance Premium Paid Loans
export const GET_INSURANCE_PREMIUM_PAID_LOANS = 'GET_INSURANCE_PREMIUM_PAID_LOANS';

// TVR application Details
export const GET_SINGLE_TVR_APPLICATION = 'GET_SINGLE_TVR_APPLICATION';

// All TVR Applications
export const GET_TVR_APPLICATIONS = 'GET_TVR_APPLICATIONS';

// Current TVR Application Id
export const SET_CURRENT_TVR_APPLICATION_ID = 'SET_CURRENT_TVR_APPLICATION_ID';

export const GET_APPLICATIONS_SUMMARY_VIEWS = 'GET_APPLICATIONS_SUMMARY_VIEWS';

// Reports

export const GET_LEAD_REPORTS = 'GET_LEAD_REPORTS';
export const GET_APPLICATIONS_REPORT = 'GET_APPLICATIONS_REPORT';
export const GET_LIMIT_SANCTION_REPORT = 'GET_LIMIT_SANCTION_REPORT';
export const GET_TRANCHE_REPORT = 'GET_TRANCHE_REPORT';
export const GET_SUPPLIER_REPORT = 'GET_SUPPLIER_REPORT';
export const GET_DEMAND_REPORT = "GET_DEMAND_REPORT";
export const GET_REPAYMENT_REPORT = "GET_REPAYMENT_REPORT";
export const GET_ACTIVE_CUSTOMER_REPORT = "GET_ACTIVE_CUSTOMER_REPORT";
export const GET_APPLICATION_ANALYTICS = "GET_APPLICATION_ANALYTICS";
export const GET_PAYMENT_TRANSACTION_REPORT = "GET_PAYMENT_TRANSACTION_REPORT";
export const GET_QUERY_MANAGEMENT_REPORT = "GET_QUERY_MANAGEMENT_REPORT";

export const GET_REPORT_VIEWS = "GET_REPORT_VIEWS";


// Tasks
export const GET_ALL_TASKS = 'GET_ALL_TASKS';
export const GET_SINGLE_TASK = 'GET_SINGLE_TASK';
export const GET_ALL_SUBTASKS = 'GET_ALL_SUBTASKS';
export const GET_ALL_TASK_STATUSES = 'GET_ALL_TASK_STATUSES';
export const GET_ALL_TASK_PRIORITIES = 'GET_ALL_TASK_PRIORITIES';
export const GET_ALL_TASK_TYPES = 'GET_ALL_TASK_TYPES';
export const GET_ALL_TASK_CATEGORIES = 'GET_ALL_TASK_CATEGORIES';
export const GET_ALL_OFFICERS = 'GET_ALL_OFFICERS';
export const GET_DASHBOARD_SUMMARY = 'GET_DASHBOARD_SUMMARY';
export const GET_RECENT_UPDATES = 'GET_RECENT_UPDATES';

// Leads
export const LEADS_LOADER = 'LEADS_LOADER';
export const LEADS_ERROR = 'LEADS_ERROR';
export const GET_SINGLE_LEADS = 'GET_SINGLE_LEADS';
export const GET_LEADS = 'GET_LEADS';
export const SET_CURRENT_LEAD_ID = 'SET_CURRENT_LEAD_ID';


// User Management
export const USER_ERROR = 'USER_ERROR';
export const USER_LOADER = 'USER_LOADER';
export const GET_OFFICERS = 'GET_OFFICERS';
export const GET_ALL_OFFICERS_LIST = 'GET_ALL_OFFICERS_LIST';
export const GET_ALL_PERMISSIONS = 'GET_ALL_PERMISSIONS';
export const GET_ALL_ROLES = 'GET_ALL_ROLES';
export const GET_ELIGIBLE_OFFICERS = 'GET_ELIGIBLE_OFFICERS';
export const FETCH_OFFICER_PERMISSIONS = 'FETCH_OFFICER_PERMISSIONS';
export const GET_OFFICER_PROFILE = 'GET_OFFICER_PROFILE';
export const GET_OFFICER_PROFILE_LOADING = 'GET_OFFICER_PROFILE_LOADING';
export const GET_OFFICER_PROFILE_ERROR = 'GET_OFFICER_PROFILE_ERROR';
export const CLEAR_OFFICER_PROFILE = 'CLEAR_OFFICER_PROFILE';
export const GET_ALL_DEPARTMENTS = "GET_ALL_DEPARTMENTS";


// Branch Management
export const BRANCH_APPLICATIONS_LOADER = 'BRANCH_APPLICATIONS_LOADER';
export const BRANCH_APPLICATIONS_ERROR = 'BRANCH_APPLICATIONS_ERROR';
export const GET_BRANCH_APPLICATIONS = 'GET_BRANCH_APPLICATIONS';
export const GET_APPLICATIONS_SUMMARY = 'GET_APPLICATIONS_SUMMARY';
export const GET_ALL_ACTIVE_BRANCHES = 'GET_ALL_ACTIVE_BRANCHES';

// Analytics Dashboard
export const ANALYTICS_LOADER = 'ANALYTICS_LOADER';
export const ANALYTICS_ERROR = 'ANALYTICS_ERROR';
export const GET_ANALYTICS_VIEWS = 'GET_ANALYTICS_VIEWS';

// Team Overview
export const TEAM_OVERVIEW_ERROR = 'TEAM_OVERVIEW_ERROR';
export const TEAM_OVERVIEW_LOADING = 'TEAM_OVERVIEW_LOADING';
export const GET_APPLICATIONS_LIST_BRANCHWISE = 'GET_APPLICATIONS_LIST_BRANCHWISE';